// extracted by mini-css-extract-plugin
export default {"formContainer":"styles_formContainer__yAvZ-","billingSummary":"styles_billingSummary__QVj9o","amount":"styles_amount__tcoDa","amountLabel":"styles_amountLabel__O5hVL"};